import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';

interface StyledLinkEditorProps {
	isActive: boolean;
	hasEditableImage: boolean;
	borderWidth: number;
}

const StyledLinkEditor = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1;
	color: ${(props: StyledLinkEditorProps) => props.isActive ?
		`${NewStyleColor.Blue100}` : `${NewStyleColor.Grey400}`
	};
	border: ${(props: StyledLinkEditorProps) => `${props.borderWidth}px`} dashed currentColor;
	pointer-events: ${(props: StyledLinkEditorProps) => props.hasEditableImage ? 'none' : 'auto'};
`;

const IconLink = styled('div')`
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	background-color: currentColor;

	svg {
		width: 14px;
		height: 14px;
		fill: ${NewStyleColor.White};
	}
`;

export {
	StyledLinkEditor,
	IconLink,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/LinkEditor/styles.ts